import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingHeicToPngConfig } from '@/data/landingConfig/landingHeicToPngConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_HeicToPng } from './schemaObject';

interface Props {}
const HeicToPngConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_HeicToPng} />
			<LandingTemplate
				data={landingHeicToPngConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default HeicToPngConverter;
